// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconS } from "../../../icons/mono/build/icon-s.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconS.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SIcon.displayName = 'SIcon';
}

export default SIcon;